import { supabase } from '@/lib/supabase'

export type RoleAnalysisPolicy = {
  role: string
  analysis_enabled: boolean
}

export type PlanAnalysisPolicy = {
  plan_id: string
  analysis_enabled: boolean
}

export async function fetchRoleAnalysisPolicies(): Promise<RoleAnalysisPolicy[]> {
  const { data, error } = await supabase
    .from('role_analysis_policies')
    .select('role,analysis_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleAnalysisPolicy[]
}

export async function upsertRoleAnalysisPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_analysis_policies')
    .upsert({ role, analysis_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanAnalysisPolicies(): Promise<PlanAnalysisPolicy[]> {
  const { data, error } = await supabase
    .from('plan_analysis_policies')
    .select('plan_id,analysis_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanAnalysisPolicy[]
}

export async function upsertPlanAnalysisPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_analysis_policies')
    .upsert({ plan_id: planId, analysis_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}

